function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import Ajv from 'ajv';
import { objectIdSchema } from "./commonSchemas";
import { unique } from "../../api/utils/filters";
import { wrapValidator } from "../tsUtils";


const ajv = new Ajv({ allErrors: true });
ajv.addVocabulary(['tsType']);

export const emitSchemaTypes = true;

export let AccessLevels = /*#__PURE__*/function (AccessLevels) {AccessLevels["READ"] = "read";AccessLevels["WRITE"] = "write";return AccessLevels;}({});




export let MixedAccess = /*#__PURE__*/function (MixedAccess) {MixedAccess["MIXED"] = "mixed";return MixedAccess;}({});





export let PermissionType = /*#__PURE__*/function (PermissionType) {PermissionType["USER"] = "user";PermissionType["GROUP"] = "group";PermissionType["PUBLIC"] = "public";return PermissionType;}({});





export const permissionType = { type: 'string', enum: Object.values(PermissionType) };
export const permissionLevel = {
  type: 'string',
  enum: Object.values(_objectSpread(_objectSpread({}, AccessLevels), MixedAccess))
};

export const permissionSchema = {
  type: 'object',
  additionalProperties: false,
  definitions: { objectIdSchema },
  properties: {
    refId: objectIdSchema,
    type: permissionType,
    level: permissionLevel
  },
  required: ['refId', 'type', 'level']
};

ajv.addKeyword({
  keyword: 'uniqueIds',
  type: 'object',
  errors: true,
  validate: (fields, data) => {
    const allowedIds = data.permissions.map((item) => item.refId);
    const uniqueIds = allowedIds.filter(unique);
    if (allowedIds.length !== uniqueIds.length) {
      throw new Ajv.ValidationError([
      {
        keyword: 'duplicatedPermissions',
        schemaPath: '',
        params: { keyword: 'duplicatedPermissions', fields },
        message: 'Permissions should be unique by person/group',
        instancePath: '.permissions'
      }]
      );
    }
    return true;
  }
});

export const permissionsDataSchema = {
  type: 'object',
  additionalProperties: false,
  definitions: { objectIdSchema },
  properties: {
    ids: { type: 'array', items: { type: 'string' } },
    permissions: {
      type: 'array',
      items: _objectSpread({}, permissionSchema)
    }
  },
  required: ['ids', 'permissions']
};

export const validateUniquePermissions = wrapValidator(
  ajv.compile({ type: 'object', uniqueIds: true })
);